export const FIELD_NAMES = {
    EMAIL: 'email',
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirm_password',
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    CPF: 'cpf',
    RG: 'rg',
    PROFESSION: 'profession',
    BIRTH_DATE: 'birth_date',
    GENDER: 'gender',
    PHONE: 'phone',
    POSTAL_CODE: 'postal_code',
    STREET: 'street',
    NEIGHBORHOOD: 'neighborhood',
    NUMBER: 'number',
    CITY: 'city',
    STATE: 'state',
    COMPLEMENT: 'complement',
    CLIENT_TYPE: 'client_type',
    JUDICIAL_TERM_PDF: 'judicial_term_pdf',
    CONSENT_TERM_PDF: 'consent_term_pdf',
    DEP_FIRST_NAME: 'dep_first_name',
    DEP_LAST_NAME: 'dep_last_name',
    DEP_CPF: 'dep_cpf',
    DEP_RG: 'dep_rg',
    DEP_BIRTH_DATE: 'dep_birth_date',
    DEP_GENDER: 'dep_gender',
    DEP_MEDICAL_CONDITION: 'dep_medical_condition',
    DEP_MEDICAL_REPORT_PDF: 'dep_medical_report_pdf',
};

export const GENDER_OPTIONS = [
    {label: 'Masculino', value: 'MALE'},
    {label: 'Feminino', value: 'FEMALE'},
    {label: 'Outro', value: 'OTHER'},
];
